import { render, staticRenderFns } from "./Service5Table.vue?vue&type=template&id=84e66d2a&"
import script from "./Service5Table.vue?vue&type=script&lang=js&"
export * from "./Service5Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports